export default {
  appName: 'Pet Care Note',
  loading: '読み込み中...',
  loadingPet: 'ペットデータを読み込み中...',
  error: 'エラー',
  success: '成功',
  cancel: 'キャンセル',
  confirm: '確認',
  save: '保存',
  delete: '削除',
  edit: '編集',
  close: '閉じる',
  back: '戻る',
  next: '次へ',
  previous: '前へ',
  submit: '送信',
  search: '検索',
  filter: 'フィルター',
  sort: '並べ替え',
  yes: 'はい',
  no: 'いいえ',
  optional: '任意',
  required: '必須',
  add: '追加',
  unknown: '不明',
  
  // Pet species translations
  species: {
    all: 'すべてのタイプ',
    pets: '匹',
    dog: '犬',
    cat: '猫',
    bird: '鳥',
    fish: '魚',
    rabbit: 'ウサギ',
    hamster: 'ハムスター',
    guinea_pig: 'モルモット',
    reptile: '爬虫類',
    turtle: 'カメ',
    other: 'その他'
  },
  
  // Pet species descriptions
  loyalCompanion: '忠実な仲間',
  independentPartner: '独立したパートナー',
  cleverSinger: '賢い歌手',
  peacefulWatcher: '穏やかな見守り',
  gentleFriend: '優しい友達',
  livelySprite: '活発な妖精',
  wiseElder: '賢い長老',
  specialPartner: '特別なパートナー',
  
  // Time units
  time: {
    years: '年',
    year: '年',
    months: 'ヶ月',
    month: 'ヶ月',
    days: '日',
    day: '日',
    hours: '時間',
    hour: '時間',
    minutes: '分',
    minute: '分',
    today: '今日',
    tomorrow: '明日'
  },
  
  actions: {
    getStarted: '始める',
    learnMore: '詳細を見る',
    signUp: '登録',
    signIn: 'ログイン',
    signOut: 'ログアウト',
    viewDetails: '詳細を表示',
    addNew: '新規追加',
    add: '追加',
    update: '更新',
    remove: '削除',
    share: '共有',
    download: 'ダウンロード',
    upload: 'アップロード',
    refresh: '更新',
    retry: '再試行',
  },
  
  validation: {
    required: 'この項目は必須です',
    invalidEmail: '無効なメールアドレス',
    invalidPhone: '無効な電話番号',
    passwordTooShort: 'パスワードは8文字以上必要です',
    passwordsDoNotMatch: 'パスワードが一致しません',
    invalidDate: '無効な日付',
    invalidUrl: '無効なURL',
  },
  
  messages: {
    saveSuccess: '保存しました',
    deleteSuccess: '削除しました',
    updateSuccess: '更新しました',
    errorOccurred: 'エラーが発生しました',
    noData: 'データがありません',
    confirmDelete: '本当に削除しますか？',
    unsavedChanges: '保存されていない変更があります。本当に離れますか？',
    loadingPet: 'ペットデータを読み込み中...',
  },
  
  errors: {
    failedToFetch: 'サーバーに接続できません。ネットワーク接続を確認してください'
  },

  seo: {
    home: {
      title: 'Pet Care Note - 総合ペット健康管理システム | 簡単ペット健康追跡',
      description: 'Pet Care Noteでペットの健康、食事、ケアプランを簡単に管理。予防接種、薬、獣医訪問を追跡し、多言語インターフェース（英語、中国語、日本語）をサポート。無料で使用でき、いつでもどこでもあなたの毛皮の友達をケアできます。',
      keywords: 'ペット健康管理, ペット記録, ペット健康追跡, ペットワクチン記録, ペット医療記録, ペットケア, ペット給餌計画, 多言語ペットアプリ'
    },
    features: {
      title: '機能 - Pet Care Note | 完全なペット管理ツール',
      description: 'Pet Care Noteの強力な機能を探索：完全なペットプロフィール、安全な共有、健康追跡、薬のリマインダー、多言語サポートなど。ペットのケアに必要なすべて。',
      keywords: 'ペット管理機能, ペット健康追跡, 薬のリマインダー, 獣医予約, ペット共有, 多言語ペットアプリ, ペットケアツール'
    },
    about: {
      title: '私たちについて - Pet Care Note | 私たちの使命とストーリー',
      description: '世界中のペット飼い主に最高のペット健康管理ツールを提供するPet Care Noteの使命について学びます。私たちのストーリーとペットケアの卓越性へのコミットメントを探索してください。',
      keywords: 'ペット健康管理について, ペットケアミッション, ペット健康管理会社, ペットケアストーリー, ペットケアチーム'
    },
    contact: {
      title: 'お問い合わせ - Pet Care Note | サポートと回答を得る',
      description: 'ヘルプが必要ですか、質問がありますか？Pet Care Noteサポートチームにお問い合わせください。ペット健康管理、アカウントの問題、または機能リクエストに関する質問にお答えします。',
      keywords: 'ペット健康管理お問い合わせ, ペットケアサポート, カスタマーサービス, ヘルプセンター, ペットケア質問, 技術サポート'
    },
    privacy: {
      title: 'プライバシーポリシー - Pet Care Note | あなたのデータ保護',
      description: 'Pet Care Noteのプライバシーポリシーを読んで、個人情報とペットデータをどのように保護し処理するかを理解してください。あなたのプライバシーとセキュリティは私たちの最優先事項です。',
      keywords: 'プライバシーポリシー, データ保護, ペットデータセキュリティ, 個人情報, GDPR準拠, データプライバシー'
    },
    terms: {
      title: '利用規約 - Pet Care Note | ユーザー契約',
      description: 'Pet Care Noteの利用規約とユーザー契約を表示します。ペット健康管理プラットフォームを使用する際の権利と責任を理解してください。',
      keywords: '利用規約, ユーザー契約, 規約と条件, サービス規約, 法的条項, ユーザー権利'
    },
    dashboard: {
      title: 'ダッシュボード - Pet Care Note | ペットを管理',
      description: 'Pet Care Noteダッシュボードにアクセスして、すべてのペットの健康情報、スケジュール、ケアプランを一箇所で表示および管理します。',
      keywords: 'ペットダッシュボード, ペット管理, ペット健康概要, ペットケアダッシュボード'
    },
    blog: {
      title: 'ブログ - Pet Care Note | ペットケアのヒントとガイド',
      description: '専門的なペットケアアドバイス、健康のヒント、トレーニングガイド、ペットの健康に関する最新ニュースを発見してください。Pet Care Noteの包括的なブログで情報を入手してください。',
      keywords: 'ペットケアブログ, ペット健康ヒント, ペットトレーニングガイド, ペットウェルネス, ペットケアアドバイス, ペット栄養, ペット行動'
    }
  }
};